import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f5a9a614&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f5a9a614&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a9a614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5a9a614')) {
      api.createRecord('f5a9a614', component.options)
    } else {
      api.reload('f5a9a614', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f5a9a614&scoped=true", function () {
      api.rerender('f5a9a614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/deliveryAddress/index.vue"
export default component.exports